module.exports = __webpack_public_path__ + "static/media/FM__VSFC__TradingView_Promotion_December_2024.88c6a254.pdf";